import defaultProfile from './defaultProfile.json';

function getDefaultProfile (useDefault = true) {
    if (!useDefault) {
        return {};
    }
    return defaultProfile.data;
}

export default getDefaultProfile;